import { Navigate } from "@tanstack/react-router";
import type { ComponentType } from "react";

type Props = {
  to: string;
  action: string;
  mask: string;
  /**
   * State for the overlay being opened, carried on the mask contract's
   * `prefill` key. Unlike ad-hoc search keys, `prefill` is declared by
   * `maskSearchFragment` on every participating route, so it survives
   * the destination route's `validateSearch` (which strips undeclared
   * keys) and is cleared by `useCloseMaskDialog` on close.
   */
  prefill?: Record<string, unknown>;
  /**
   * Search params kept visible on the masked URL (e.g. a share link's
   * `session-id`), so the address bar stays a re-shareable deep link
   * and a reload re-enters the shim with the same state.
   */
  maskSearch?: Record<string, unknown>;
};

// to/mask are user-supplied literals, not resolvable at module type-level.
// Casts match the pattern in @/hooks/use-query-state.ts.
const NavigateAny = Navigate as unknown as ComponentType<{
  to: string;
  search: (prev: Record<string, unknown>) => Record<string, unknown>;
  mask: { to: string; search?: Record<string, unknown> };
}>;

export function MaskRedirect({ to, action, mask, prefill, maskSearch }: Props) {
  return (
    <NavigateAny
      to={to}
      search={(prev) => ({
        ...prev,
        action,
        ...(prefill ? { prefill } : {}),
      })}
      mask={{ to: mask, ...(maskSearch ? { search: maskSearch } : {}) }}
    />
  );
}
